import { Avatar, Toolbar } from "@mui/material";
import styles from "./headerOffer.module.css";
import { AccountCircle } from "@mui/icons-material";
import { useEffect, useState } from "react";
import UserService, { User } from "@/services/UserService";
import { red } from "@mui/material/colors";
import logoBranca from "../../assets/LogoBranca.png";
import HowToRegTwoToneIcon from "@mui/icons-material/HowToRegTwoTone";


interface headereEstilization {
  headerOfferEstyle?: boolean;
}

export function HeaderOfferComponent({
  headerOfferEstyle,
}: headereEstilization) {
  const imageUrl =
    "https://lh3.googleusercontent.com/a/ACg8ocJp3K2NJRLfinQXB2vnZXd049gpmh9rC5DExSkEh9wJXwjFJevf=s288-c-no";

  const [user, setUser] = useState<User>();

  function choiceStyle(headerOfferEstyle?: boolean) {
    return headerOfferEstyle
      ? styles.headerOfferEstyle
      : styles.headerOffer;
  }
  useEffect(() => {
    setUser(UserService.getUser());
  }, []);

  return (
    <>
      <Toolbar className={choiceStyle(headerOfferEstyle)}>
        <div className={styles.leftPosition}>
          <img
            src={logoBranca}
            alt="VIVA MÓVEIS Logo"
            className={styles.logo}
          />
        </div>
        <div className={styles.heigthPosition}>
          {imageUrl ? (
            <>
              <p className={styles.nome_usuario}>
                {user?.name ?? "John Doe"}
              </p>
              <Avatar sx={{ color: red[500] }} className="list-item-avatar">
                <HowToRegTwoToneIcon />
              </Avatar>
            </>
          ) : (
            <AccountCircle />
          )}
        </div>
      </Toolbar>
    </>
  );
}
